import api from './api';

const pagePayload = (data) => {
  if (data?.content && data?.page) {
    return data;
  }
  // Spring Page JSON default shape
  return {
    content: data?.content || [],
    page: {
      totalElements: data?.totalElements ?? 0,
      totalPages: data?.totalPages ?? 0,
      number: data?.number ?? 0,
    },
  };
};

export const listMyWidgetTickets = async ({ page = 0, size = 20, status = [] } = {}) => {
  const params = new URLSearchParams();
  params.append('page', String(page));
  params.append('size', String(size));
  (status || []).forEach((code) => {
    if (code) params.append('status', code);
  });
  const response = await api.get(`/api/private/widgets/my-tickets?${params.toString()}`);
  return pagePayload(response.data);
};

export const getMyWidgetTicket = async (ticketId) => {
  const response = await api.get(`/api/private/widgets/my-tickets/${encodeURIComponent(ticketId)}`);
  return response.data;
};

export const listMyWidgetTicketMessages = async (ticketId) => {
  const response = await api.get(
    `/api/private/widgets/my-tickets/${encodeURIComponent(ticketId)}/messages`
  );
  return response.data;
};

export const listMyWidgetTicketAttachments = async (ticketId) => {
  const response = await api.get(
    `/api/private/widgets/my-tickets/${encodeURIComponent(ticketId)}/attachments`
  );
  return response.data;
};

export const commentOnMyWidgetTicket = async (ticketId, content, attachments = []) => {
  const response = await api.post(
    `/api/private/widgets/my-tickets/${encodeURIComponent(ticketId)}/messages`,
    {
      content: content || '',
      isSupportResponse: false,
      attachments: Array.isArray(attachments) ? attachments : [],
    }
  );
  return response.data;
};

export const resolveMyWidgetTicket = async (ticketId) => {
  const response = await api.put(
    `/api/private/widgets/my-tickets/${encodeURIComponent(ticketId)}/resolve`
  );
  return response.data;
};
